import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true
})
export class SortByPipe implements PipeTransform {
  transform(array: any[] | null | undefined, field: string, direction: 'asc' | 'desc' = 'asc'): any[] {
    if (!array || !field) return array ?? [];

    return [...array].sort((a, b) => {
      const valA = String(a?.[field] ?? '').toLowerCase();
      const valB = String(b?.[field] ?? '').toLowerCase();

      const cmp = valA.localeCompare(valB, undefined, { sensitivity: 'base' });
      return direction === 'asc' ? cmp : -cmp;
    });
  }
}
